module.exports = __webpack_public_path__ + "static/media/arts_1.0b0a985e.jpg";